// submit-product.js
document.addEventListener("DOMContentLoaded", () => {
  window.uploadUI.init("product-drop-area", "fileElem", "preview");

  const form = document.querySelector(".add-product-wrap-form");
  if (!form) return;

  const externalLink = form.querySelector("#external-link");
  if( externalLink ) {
      externalLink.addEventListener("blur", () => {
          let v = externalLink.value.trim();
      if (v && !/^https?:\/\//i.test(v)) {
          externalLink.value = "https://" + v;
      }
    });
  }


  function productAddModal(
    message,
    title = "Attention required",
    isSuccess = false,
    redirectUrl = null
  ) {
    const modalTitle = document.querySelector(".custom-message-modal-title");
    const modalFooter = document.querySelector(".custom-message-modal-footer");
    const modalMessage = document.querySelector(".custom-message-modal-body p");
    const modalTriggerBtn = document.querySelector(".open-modal-btn");
    const modalCloseBtn = document.querySelector(".custom-message-modal-close");
      const modal = document.querySelector(".custom-message-modal-overlay");
    // Clear previous buttons
    if (modalFooter) {
      modalFooter.innerHTML = "";

      const confirmButton = document.createElement("button");
      confirmButton.className =
        "custom-message-modal-btn btn btn-primary btn-xs new-product";
      confirmButton.textContent = "Ok";

      // Add click handler to close modal here:
      confirmButton.onclick = () => {
        const modal = document.querySelector(".custom-message-modal-overlay");
        if (modal) {
          modal.classList.remove("d-flex"); // or whatever class shows the modal

          // if (redirectUrl) {
          //     window.location.href = redirectUrl;
          // }
        }
      };


      modalFooter.appendChild(confirmButton);
    }
    if (redirectUrl) modal.dataset.redirect = redirectUrl;
    else delete modal.dataset.redirect;

    if (modalTitle) {
      modalTitle.textContent = title;
    }

    if (modalMessage) {
      if (isSuccess) {
        //modalMessage.textContent = message;
          modalMessage.innerHTML = message;
      } else {
        modalMessage.innerHTML = `<p class="whitespace-pre-line">${message}</p>`;
      }
    }

    if (modalTriggerBtn) {
      modalTriggerBtn.click();
    }
  }

  document.addEventListener("click", function (e) {

      // Close (X) button
      const closeBtn = e.target.closest(".custom-message-modal-close");
      if (closeBtn) {
          const modal = document.querySelector(".custom-message-modal-overlay");
          const redirectUrl = modal.dataset.redirect;
          modal.classList.remove("d-flex");
          if (redirectUrl) window.location.href = redirectUrl;
          return;
      }
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const formType = form.getAttribute("data-type"); // get the form type

    // pushing the textarea div element to   text area element
    if (window.quillEditors && window.quillEditors.length > 0) {
      window.quillEditors.forEach(({ quill, textarea }) => {
        if (textarea) {
          textarea.value = quill.root.innerHTML;
        }
      });
    }

    const errors = [];



    // Validate required input fields
    const name = form.querySelector("#product-name");
    const detailFeature = form.querySelector("#detail-feature");
    if (!name.value.trim())
    errors.push({
      message: "Product name is required",
      scrollDiv: ".dashobard--marketplace",
      attrId: "product-name",
    });



    const regularPrice = form.querySelector("#regular-price");
    // const salePrice = form.querySelector("#sale-price");
    const productSpecs = form.querySelector("#product-specifications");
    // const categorySelect = form.querySelector("#categorySelect");
    // const selectedCategories = [...categorySelect.selectedOptions].filter(
    //   (opt) => opt.value
    // );
    const externalLink = form.querySelector("#external-link");

    if (!detailFeature.value.trim())
      errors.push({
        message: "Product Summary are required",
        scrollDiv: "#product-name",
        attrId: "detail-feature",
      });

    // Conditional fields for non-clinic forms
    if (formType !== "clinic" && formType !== "placement" ) {

      const categorySelect = form.querySelector("#categorySelect");
      const selectedCategories = [...categorySelect.selectedOptions].filter(
          (opt) => opt.value
      );
      if (selectedCategories.length === 0)
        errors.push({
          message: "At least one category must be selected",
          scrollDiv: "#detail-feature",
          attrId: "categorySelect",
        });
      if (selectedCategories.length === 0) {
        errors.push({
          message: "At least one category must be selected",
          scrollDiv: "#detail-feature",
          attrId: "categorySelect",
        });
      }
    }

    // Validate image upload
    const selectedFiles = window.uploadUI.getSelectedFiles();
      /*
      if (!selectedFiles || selectedFiles.length === 0) {
        errors.push({
          message: "Please upload at least one product image.",
          scrollDiv: "#categorySelect",
          attrId: "employer-type",
        });
      }*/

    const errorElements = document.querySelectorAll(".err");
    if (errorElements) errorElements.forEach((el) => el.remove());

    if (errors.length > 0) {
      errors.forEach((error) => {

        console.log(error.attrId);
        const errID = document.getElementById(error.attrId);
        const errMessage = error.message;
        if (errID) {
          const p = document.createElement("p");
          p.className = "err";
          p.textContent = errMessage;
          errID.after(p);
        }
      });

      // productAddModal('<p>Please fill in all necessary details to proceed.</p>');

      const target = document.querySelector(errors[0].scrollDiv);
      if (target) target.scrollIntoView({ behavior: "smooth" });
      return;
    }

    // Prepare form data
    const formData = new FormData(this);

    formData.delete("product_images[]");

    selectedFiles.forEach((file) => {
      if (file && file.size > 0 && file.name) {
        formData.append("product_images[]", file);
      }
    });

    const files = formData.getAll("product_images[]");

    if( formType == "clinic" ) {
      formData.append("action", "submit_new_clinic");
    } else if( formType == "placement" ) {
      formData.append("action", "submit_new_placement");
    } else {
      formData.append("action", "submit_new_product");
    }
    formData.append("nonce", window.ajax_callback_data.ajax_nonce);

    const modalTitle = document.querySelector(".custom-message-modal-title");
    const modalBody = document.querySelector(".custom-message-modal-body p");
    if (modalTitle) modalTitle.textContent = "Please wait";

    if( formType == "clinic" || formType == "placement" ) {
      if (modalBody) modalBody.textContent = "Adding new clinic...";
    } else {
      if (modalBody) modalBody.textContent = "Adding new product...";
    }
    // Hide unused buttons if they exist
    const confirmUpdate = document.querySelector(
      ".custom-message-modal-btn.confirm"
    );
    const confirmBtnCancel = document.querySelector(
      ".custom-message-modal-btn.btn-delete.cancel"
    );

    if (confirmUpdate) confirmUpdate.style.display = "none";
    if (confirmBtnCancel) confirmBtnCancel.style.display = "none";

    if (document.querySelector(".custom-message-modal-btn.new-product")) {
      document.querySelector(".custom-message-modal-btn.new-product").remove();
    }

    const modalTriggerBtn = document.querySelector(".open-modal-btn");
    if (modalTriggerBtn) {
      modalTriggerBtn.click();
    }

    fetch(window.ajax_callback_data.ajax_url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          // console.log( response.data.redirecturl );
          form.reset();
          productAddModal(response.data.success_message, "Confirmation", true, response.data.redirecturl);
          document.getElementById("preview").innerHTML = "";
          document
            .querySelector(".custom-message-modal-btn.new-product")
            .remove();
          window.uploadUI.clearAll();
          // window.location.href = response.data.redirecturl;

        } else {
          productAddModal(
            "Error: " + (response.data?.message || "Unknown error")
          );
        }
      })
      .catch((error) => {
        console.error(error);
        productAddModal("Unexpected error");
      });
  });
});
